<script setup>
import { computed } from "vue";
import MessageAlert from "@/components/MessageAlert.vue";
import { useAppNotificationStore } from "@/state/modules/app-notification";

const appNotificationStore = useAppNotificationStore();

const notificationMessage = computed(() => appNotificationStore.message);
const notificationVariant = computed(() => appNotificationStore.variant);
</script>

<template>
  <div class="app-notification">
    <MessageAlert
      v-if="notificationMessage"
      :message="notificationMessage"
      :variant="notificationVariant"
      @close="appNotificationStore.clear()" />
  </div>
  <router-view :key="$route.fullPath"></router-view>
</template>

<style lang="scss">
.app-notification {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 1100;
  width: calc(100vw - 2rem);
  max-width: 30vw;
}

.v-modal-fluid {
  .modal-dialog {
    @media (min-width: 1024.1px) {
      min-width: 90%;
    }
  }
  .modal-content {
    @media (min-width: 1024.1px) {
      background-color: var(--vz-body-bg);
    }
  }
}
</style>
